// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IMobileIdentificationCredentialActionReasonType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    externalStatus: string;
    sortOrder: number;
    active: boolean;
}

export class MobileIdentificationCredentialActionReasonType implements IMobileIdentificationCredentialActionReasonType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public externalStatus: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Fraud Suspected MobileIdentificationCredentialActionReasonType
	**/
    get FraudSuspected(): IMobileIdentificationCredentialActionReasonType {
        return this.FromId(1);
    }
    /**
		Returns Fraud Suspected Stolen Identity MobileIdentificationCredentialActionReasonType
	**/
    get FraudSuspectedStolenIdentity(): IMobileIdentificationCredentialActionReasonType {
        return this.FromId(2);
    }
    /**
		Returns Fraud Suspected Synthetic Identity MobileIdentificationCredentialActionReasonType
	**/
    get FraudSuspectedSyntheticIdentity(): IMobileIdentificationCredentialActionReasonType {
        return this.FromId(3);
    }
    /**
		Returns Other MobileIdentificationCredentialActionReasonType
	**/
    get Other(): IMobileIdentificationCredentialActionReasonType {
        return this.FromId(4);
    }
    /**
		Returns Fraud Investigation Complete MobileIdentificationCredentialActionReasonType
	**/
    get FraudInvestigationComplete(): IMobileIdentificationCredentialActionReasonType {
        return this.FromId(5);
    }
    /**
		Returns Other Investigation Complete MobileIdentificationCredentialActionReasonType
	**/
    get OtherInvestigationComplete(): IMobileIdentificationCredentialActionReasonType {
        return this.FromId(6);
    }
    /**
		Returns DL Expired MobileIdentificationCredentialActionReasonType
	**/
    get DLExpired(): IMobileIdentificationCredentialActionReasonType {
        return this.FromId(7);
    }
    /**
		Returns Duplicate MDL MobileIdentificationCredentialActionReasonType
	**/
    get DuplicateMDL(): IMobileIdentificationCredentialActionReasonType {
        return this.FromId(8);
    }
    /**
		Returns Fake DL MobileIdentificationCredentialActionReasonType
	**/
    get FakeDL(): IMobileIdentificationCredentialActionReasonType {
        return this.FromId(9);
    }
    /**
		Returns Fraud Confirmed MobileIdentificationCredentialActionReasonType
	**/
    get FraudConfirmed(): IMobileIdentificationCredentialActionReasonType {
        return this.FromId(10);
    }
    /**
		Returns Fraud Stolen Identity MobileIdentificationCredentialActionReasonType
	**/
    get FraudStolenIdentity(): IMobileIdentificationCredentialActionReasonType {
        return this.FromId(11);
    }
    /**
		Returns Fraud Synthetic Identity MobileIdentificationCredentialActionReasonType
	**/
    get FraudSyntheticIdentity(): IMobileIdentificationCredentialActionReasonType {
        return this.FromId(12);
    }
    /**
		Returns DL Canceled MobileIdentificationCredentialActionReasonType
	**/
    get DLCanceled(): IMobileIdentificationCredentialActionReasonType {
        return this.FromId(13);
    }
    /**
		Returns Customer Initiated MobileIdentificationCredentialActionReasonType
	**/
    get CustomerInitiated(): IMobileIdentificationCredentialActionReasonType {
        return this.FromId(14);
    }
    /**
		Returns Customer Issue Resolved MobileIdentificationCredentialActionReasonType
	**/
    get CustomerIssueResolved(): IMobileIdentificationCredentialActionReasonType {
        return this.FromId(15);
    }
    /**
		Returns Issuer Initiated MobileIdentificationCredentialActionReasonType
	**/
    get IssuerInitiated(): IMobileIdentificationCredentialActionReasonType {
        return this.FromId(16);
    }
    /**
		Returns Issuer Issue Resolved MobileIdentificationCredentialActionReasonType
	**/
    get IssuerIssueResolved(): IMobileIdentificationCredentialActionReasonType {
        return this.FromId(17);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'FraudSuspected', displayValue: 'Fraud Suspected', description: 'Fraud Suspected', externalStatus: 'FRAUD_SUSPECTED', sortOrder: 1, active: true });
        this._dictionary.add('2', { id: 2, value: 'FraudSuspectedStolenIdentity', displayValue: 'Fraud Suspected Stolen Identity', description: 'Fraud Suspected Stolen Identity', externalStatus: 'FRAUD_SUSPECTED_STOLEN_IDENTITY', sortOrder: 2, active: true });
        this._dictionary.add('3', { id: 3, value: 'FraudSuspectedSyntheticIdentity', displayValue: 'Fraud Suspected Synthetic Identity', description: 'Fraud Suspected Synthetic Identity', externalStatus: 'FRAUD_SUSPECTED_SYNTHETIC_IDENTITY', sortOrder: 3, active: true });
        this._dictionary.add('4', { id: 4, value: 'Other', displayValue: 'Other', description: 'Other', externalStatus: 'OTHER', sortOrder: 4, active: true });
        this._dictionary.add('5', { id: 5, value: 'FraudInvestigationComplete', displayValue: 'Fraud Investigation Complete', description: 'Fraud Investigation Complete', externalStatus: 'FRAUD_INVESTIGATION_COMPLETE', sortOrder: 5, active: true });
        this._dictionary.add('6', { id: 6, value: 'OtherInvestigationComplete', displayValue: 'Other Investigation Complete', description: 'Other Investigation Complete', externalStatus: 'OTHER_INVESTIGATION_COMPLETE', sortOrder: 6, active: true });
        this._dictionary.add('7', { id: 7, value: 'DLExpired', displayValue: 'DL Expired', description: 'DL Expired', externalStatus: 'DL_EXPIRED', sortOrder: 7, active: true });
        this._dictionary.add('8', { id: 8, value: 'DuplicateMDL', displayValue: 'Duplicate MDL', description: 'Duplicate MDL', externalStatus: 'DUPLICATE_MDL', sortOrder: 8, active: true });
        this._dictionary.add('9', { id: 9, value: 'FakeDL', displayValue: 'Fake DL', description: 'Fake DL', externalStatus: 'FAKE_DL', sortOrder: 9, active: true });
        this._dictionary.add('10', { id: 10, value: 'FraudConfirmed', displayValue: 'Fraud Confirmed', description: 'Fraud Confirmed', externalStatus: 'FRAUD_CONFIRMED', sortOrder: 10, active: true });
        this._dictionary.add('11', { id: 11, value: 'FraudStolenIdentity', displayValue: 'Fraud Stolen Identity', description: 'Fraud Stolen Identity', externalStatus: 'FRAUD_STOLEN_IDENTITY', sortOrder: 11, active: true });
        this._dictionary.add('12', { id: 12, value: 'FraudSyntheticIdentity', displayValue: 'Fraud Synthetic Identity', description: 'Fraud Synthetic Identity', externalStatus: 'FRAUD_SYNTHETIC_IDENTITY', sortOrder: 12, active: true });
        this._dictionary.add('13', { id: 13, value: 'DLCanceled', displayValue: 'DL Canceled', description: 'DL Canceled', externalStatus: 'DL_CANCELED', sortOrder: 13, active: true });
        this._dictionary.add('14', { id: 14, value: 'CustomerInitiated', displayValue: 'Customer Initiated', description: 'Customer Initiated', externalStatus: 'CUSTOMER_INITIATED', sortOrder: 14, active: true });
        this._dictionary.add('15', { id: 15, value: 'CustomerIssueResolved', displayValue: 'Customer Issue Resolved', description: 'Customer Issue Resolved', externalStatus: 'CUSTOMER_ISSUE RESOLVED', sortOrder: 15, active: true });
        this._dictionary.add('16', { id: 16, value: 'IssuerInitiated', displayValue: 'Issuer Initiated', description: 'Issuer Initiated', externalStatus: 'ISSUER_INITIATED', sortOrder: 16, active: true });
        this._dictionary.add('17', { id: 17, value: 'IssuerIssueResolved', displayValue: 'Issuer Issue Resolved', description: 'Issuer Issue Resolved', externalStatus: 'ISSUER_ISSUE_RESOLVED', sortOrder: 17, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IMobileIdentificationCredentialActionReasonType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IMobileIdentificationCredentialActionReasonType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IMobileIdentificationCredentialActionReasonType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IMobileIdentificationCredentialActionReasonType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IMobileIdentificationCredentialActionReasonType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
